import React, { useEffect, useState } from 'react'
import { Button, Input, Select, Table } from 'antd'
import 'aos/dist/aos.css'
import '../../MainCSS.css'
import { Option } from 'antd/es/mentions'
import axios from 'axios'
import { toast } from 'react-toastify'
import {
  GetHSNCodeMaster,
  GetUOMMaster,
} from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { GetJobWorkerItemMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { SaveJobWorkerItemMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { UpdateJobWorkerItemMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'
import { DeleteJobWorkerItemMaster } from '../../../AllAPI/MasterAPI/GeneralMasterApi'

const JobWorkerItemMaster = () => {
 
const userData = sessionStorage.getItem('authToken');
  const userId = sessionStorage.getItem('userId');
  const authHeaders = sessionStorage.getItem('authHeaders');
  const headersObj = JSON.parse(authHeaders).headers;

  
  const userIp = headersObj.userIp
  const deviceSign = headersObj.deviceSign
  const userLong = headersObj.userLong
  const userLat = headersObj.userLat

  const commonHeaders = {
    headers: {
      createdBy: userId,
      updatedBy: userId,
      userIp: userIp,
      userLat: userLat,
      userLong: userLong,
      deviceSign: deviceSign,
    },
  };

const commonHeaders1 = {
  headers: {
    createdBy: userId,
    updatedBy: userId,
  },
}

  const [errors, setErrors] = useState({
    workerItemName: '',
    hsnCode: '',
    uomName: '',
    goodsType: '',
    gstRate: '',
    remark: '',
  })

  const [pageSize, setPageSize] = useState(10)
  const [filteredData, setFilteredData] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [totalEntries, setTotalEntries] = useState(0)

  const [workerItemId, setWorkerItemId] = useState('')
  const [workerItemName, setWorkerItemName] = useState('')
  const [hsnCode, setHsnCode] = useState('')
  const [uomName, setUomName] = useState('')
  const [goodsType, setGoodsType] = useState('')
  const [gstRate, setGstRate] = useState('')
  const [remark, setRemark] = useState('')

  const [allHsnCode, setAllHsnCode] = useState([])
  const [allUom, setAllUom] = useState([])
  const [allJobWorkerItem, setAllJobWorkerItem] = useState([])
  const [updateButton, setUpdateButton] = useState(false)
  const [saveButton, setSaveButton] = useState(true)

  //======Search data from table===============
 
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
  
    const filtered = allJobWorkerItem.filter((item) =>
      Object.values(item).some((val) =>
        String(val ?? "").toLowerCase().includes(searchValue)
      )
    );
  
    setFilteredData(filtered);
    setTotalEntries(filtered.length);
    setCurrentPage(1);
  };

  //==========Pagination=======================
  const handlePageSizeChange = (value) => {
    setPageSize(value)
  }

  // Fetch JobWorker, Uom and HsnCode
  let isJobWorkerFetched = false
  useEffect(() => {
    if (isJobWorkerFetched) return
    fetchJobWorkItem();
    fetchUom();
    fetchHsnCode();
    isJobWorkerFetched = true
  }, [])

  // ==============Get table data================

  let isError = false

  const fetchJobWorkItem = async () => {
    try {
      const response = await axios.get(GetJobWorkerItemMaster, commonHeaders1)
      if (response.data !== null) {
        setAllJobWorkerItem(response.data)
        setFilteredData(response.data)
        setTotalEntries(response.data.length)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching Job Worker Item:', error)
        toast.error('Failed to fetch Job Worker Item data')
        isError = true
      }
    }
  }

  // const columns = [
  //   {
  //     title: 'Sr.No.',
  //     dataIndex: '',
  //     key: 'index',
  //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  //   },
  //   {
  //     title: 'Job Work Item Name',
  //     dataIndex: 'name',
  //     key: 'name',
  //   },
  //   {
  //     title: 'HSN Code',
  //     dataIndex: 'hsnCode',
  //     key: 'hsnCode',
  //   },
  //   {
  //     title: 'UOM',
  //     dataIndex: 'uom',
  //     key: 'uom',
  //   },
  //   {
  //     title: 'Type Of Goods',
  //     dataIndex: 'typeOfGoods',
  //     key: 'typeOfGoods',
  //     render: (text) => {
  //       return text === 1 ? 'Capital' : 'Inputs' ;
  //     },
  //   },
  //   {
  //     title: 'GST Rate',
  //     dataIndex: 'gstRate',
  //     key: 'gstRate',
  //   },
  //   {
  //     title: 'Remark',
  //     dataIndex: 'remarks',
  //     key: 'remarks',
  //   },
  //   {
  //     title: 'Actions',
  //     key: 'actions',
  //     render: (text, record) => (
  //       <div>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
  //           onClick={() => handleEditDataButton(record)}
  //         >
  //           <i class="fa-solid fa-pen-to-square"></i>
  //         </span>
  //         <span
  //           type="submit"
  //           style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
  //           onClick={() => handleDeleteData(record)}
  //         >
  //           <i class="fa-solid fa-trash"></i>
  //         </span>
  //       </div>
  //     ),
  //   },
  // ]

  const columns = [
  {
    title: 'Sr.No.',
    dataIndex: '',
    key: 'index',
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: 'Job Work Item Name',
    dataIndex: 'name',
    key: 'name',
    sorter: (a, b) => a.name.localeCompare(b.name), // Sorting alphabetically for name
  },
  {
    title: 'HSN Code',
    dataIndex: 'hsnCode',
    key: 'hsnCode',
    sorter: (a, b) => a.hsnCode.localeCompare(b.hsnCode), // Sorting alphabetically for HSN Code
  },
  {
    title: 'UOM',
    dataIndex: 'uom',
    key: 'uom',
    sorter: (a, b) => a.uom.localeCompare(b.uom), // Sorting alphabetically for UOM
  },
  {
    title: 'Type Of Goods',
    dataIndex: 'typeOfGoods',
    key: 'typeOfGoods',
    render: (text) => {
      return text === 1 ? 'Capital' : 'Inputs';
    },
    sorter: (a, b) => a.typeOfGoods - b.typeOfGoods, // Sorting numerically for typeOfGoods (1 for Capital, 2 for Inputs)
  },
  {
    title: 'GST Rate',
    dataIndex: 'gstRate',
    key: 'gstRate',
    sorter: (a, b) => a.gstRate - b.gstRate, // Sorting numerically for GST Rate
  },
  {
    title: 'Remark',
    dataIndex: 'remarks',
    key: 'remarks',
    sorter: (a, b) => a.remarks.localeCompare(b.remarks), // Sorting alphabetically for remarks
  },
  {
    title: 'Actions',
    key: 'actions',
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: '12px', color: '#349ff3', marginRight: '10px' }}
          onClick={() => handleEditDataButton(record)}
        >
          <i class="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: '12px', color: 'red', marginLeft: '10px' }}
          onClick={() => handleDeleteData(record)}
        >
          <i class="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
];


  const components = {
    header: {
      cell: ({ children, ...restProps }) => (
        <th
          {...restProps}
          style={{
            backgroundColor: '#023E7D',
            color: '#fff',
            padding: '10px',
            fontSize: '13px',
            borderRadius: '0px',
          }}
        >
          {children}
        </th>
      ),
    },
    body: {
      row: ({ children, ...restProps }) => (
        <tr
          {...restProps}
          style={{
            backgroundColor: '#f0f7fd',
          }}
        >
          {children}
        </tr>
      ),
      cell: ({ children, ...restProps }) => (
        <td
          {...restProps}
          style={{
            padding: '8px',
          }}
        >
          {children}
        </td>
      ),
    },
  }

  const fetchUom = async () => {
    try {
      const response = await axios.get(GetUOMMaster, commonHeaders1)
      if (response.data !== null) {
        setAllUom(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching UOM:', error)
        toast.error('Failed to fetch UOM data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  const fetchHsnCode = async () => {
    try {
      const response = await axios.get(GetHSNCodeMaster, commonHeaders1)
      if (response.data !== null) {
        setAllHsnCode(response.data)
      }
    } catch (error) {
      if (!isError) {
        console.error('Error fetching HSN Code:', error)
        toast.error('Failed to fetch HSN Code data')
        isError = true // Set the flag to prevent double toast
      }
    }
  }

  //=========CANCEL JOB WORK ITEM DATA============
  const handleCancel = () => {
    setWorkerItemName('')
    setUomName('')
    setHsnCode('')
    setGoodsType('')
    setGstRate('')
    setRemark('')
    setUpdateButton(false)
    setSaveButton(true)
    setErrors('')
  }

  //=========SAVE JOB WORK ITEM DATA============
  const handleSubmit = async () => {
    let isValid = true
    const errorObj = {}

    if (!workerItemName.trim()) {
      isValid = false
      errorObj.workerItemName = 'Job Work Item Name is required *'
    }
    if (!hsnCode) {
      isValid = false
      errorObj.hsnCode = 'HSN Code is required *'
    }
    if (!uomName) {
      isValid = false
      errorObj.uomName = 'UOM Name is required *'
    }
    if (!goodsType) {
      isValid = false
      errorObj.goodsType = 'Goods Type is required *'
    }
    if (!gstRate.trim()) {
      isValid = false
      errorObj.gstRate = 'GST Rate is required *'
    }
    if (!remark.trim()) {
      isValid = false
      errorObj.remark = 'Remark is required *'
    }

    setErrors(errorObj) // Set error messages

    if (!isValid) return

    const saveData = {
      name: workerItemName,
      hsnCodeId: hsnCode,
      uomId: uomName,
      typeOfGoods: parseFloat(goodsType),
      gstRate: parseFloat(gstRate),
      remarks: remark,
    }

    try {
      const response = await axios.post(
        SaveJobWorkerItemMaster,
        saveData,
        commonHeaders,
      )

      if (response.data === 'CREATED') {
        toast.success('Job Work Item added successfully!')
        fetchJobWorkItem()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Job Work Item already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
  }

  //=========EDIT JOB WORK ITEM DATA============
  const handleEditDataButton = (item) => {
    setUpdateButton(true)
    setSaveButton(false)

    setWorkerItemId(item.id)
    setWorkerItemName(item.name)
    setHsnCode(item.hsnCodeId)
    setUomName(item.uomId)
    setGoodsType(String(item.typeOfGoods))
    setGstRate(item.gstRate)
    setRemark(item.remarks)
  }

  //=========UPDATE JOB WORK ITEM DATA============
  const handleUpdate = async () => {
    if (
      !workerItemName ||
      !hsnCode ||
      !uomName ||
      !goodsType ||
      !gstRate ||
      !remark
    ) {
      toast.warn('Please fill all fields!')
      return
    }

    const updateData = {
      id: workerItemId,
      name: workerItemName,
      hsnCodeId: hsnCode,
      uomId: uomName,
      typeOfGoods: parseFloat(goodsType),
      gstRate: parseFloat(gstRate),
      remarks: remark,
    }

    try {
      const response = await axios.put(
        UpdateJobWorkerItemMaster,
        updateData,
        commonHeaders,
      )

      if (response.data === 'UPDATED') {
        toast.success('Job Work Item updated successfully!')
        fetchJobWorkItem()
        handleCancel()
      } else if (response.data === 'ALREADYEXISTED') {
        toast.warn('Job Work Item already exist!')
      }
    } catch (error) {
      console.error('Error during API call:', error)
      toast.error('Error occurred while updating data')
    }
  }

  //=========DELETE JOB WORK ITEM DATA============
  const handleDeleteData = async (item) => {
    const confirmDelete = window.confirm(
      `Are you sure you want to delete the Work Item Name "${item.name}"?`,
    )
    if (!confirmDelete) return

    try {
      const response = await axios.delete(
        `${DeleteJobWorkerItemMaster}?id=${item.id}`,
        commonHeaders1,
      )
      if (response.data === 'DELETED') {
        toast.success('Job Work Item deleted successfully!')
        fetchJobWorkItem()
        handleCancel()
      }
    } catch (error) {
      console.error('Error during delete operation:', error)
      toast.error('Error occurred while deleting the Job Work Item')
    }
  }

  const goodTypesOptions = [
    { value: '1', label: 'Capital' },
    { value: '2', label: 'Inputs' },
  ]

  return (
    <>
     <div className="px-5 py-3">
        <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
              <div className="col-12 col-lg-3"></div>
              <div className="col-12 col-lg-6">
                <div className="row p-0 m-0">
                  <div className="col-12 py-1">
                    <label className="labels">Item Name</label>
                    <Input
                      value={workerItemName}
                      onChange={(e) => setWorkerItemName(e.target.value)}
                      placeholder="Enter Name"
                      maxLength={250}
                    />
                    {errors.workerItemName && (
                      <div className="errorField">{errors.workerItemName}</div>
                    )}
                  </div>
                </div>

                <div className="row p-0 m-0">
                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">HSN Code</label>
                    <Select
                      value={hsnCode || undefined}
                      onChange={setHsnCode}
                      showSearch
                      className="w-100"
                      placeholder="Select HSN"
                      optionFilterProp="children"
                    >
                      {allHsnCode.map((hsn) => (
                        <Option key={hsn.id} value={hsn.id}>
                          {hsn.hsnCode}
                        </Option>
                      ))}
                    </Select>
                    {errors.hsnCode && (
                      <div className="errorField">{errors.hsnCode}</div>
                    )}
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">UOM</label>
                    <Select
                      value={uomName || undefined}
                      onChange={setUomName}
                      showSearch
                      className="w-100"
                      placeholder="Select UOM"
                      optionFilterProp="children"
                    >
                      {allUom.map((uom) => (
                        <Option key={uom.id} value={uom.id}>
                          {uom.uom}
                        </Option>
                      ))}
                    </Select>
                    {errors.uomName && (
                      <div className="errorField">{errors.uomName}</div>
                    )}
                  </div>
                </div>

                <div className="row p-0 m-0">
                  
                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">Type Of Goods</label>
                    <Select
                      value={goodsType || undefined}
                      onChange={setGoodsType}
                      showSearch
                      className="w-100"
                      placeholder="Select Type"
                      optionFilterProp="children"
                    >
                      {goodTypesOptions.map((opt) => (
                        <Option key={opt.value} value={opt.value}>
                          {opt.label}
                        </Option>
                      ))}
                    </Select>
                    {errors.goodsType && (
                      <div className="errorField">{errors.goodsType}</div>
                    )}
                  </div>

                  <div className="col-md-6 col-lg-6 py-1">
                    <label className="labels">GST Rate</label>
                    <Input type='number'
                      value={gstRate}
                      onChange={(e) => setGstRate(e.target.value)}
                      placeholder="Enter Rate"
                      maxLength={250}
                    />
                    {errors.gstRate && (
                      <div className="errorField">{errors.gstRate}</div>
                    )}
                  </div>

                  <div className="col-12 py-1">
                    <label className="labels">Remark</label>
                    <Input.TextArea
                      value={remark}
                      onChange={(e) => setRemark(e.target.value)}
                      placeholder="Enter Remark"
                      maxLength={250}
                    />
                    {errors.remark && (
                      <div className="errorField">{errors.remark}</div>
                    )}
                  </div>
                </div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  {saveButton && (
                    <Button
                      type="submit"
                      className="SubmitBtn mx-1"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  )}
                  {updateButton && (
                    <Button
                      type="submit"
                      className="UpdateBtn mx-1"
                      onClick={handleUpdate}
                    >
                      Update
                    </Button>
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3"></div>

              <div
                className="col-12 p-0 mt-3"
                style={{ borderBottom: '2px solid rgb(207, 207, 207)' }}
              ></div>
            </div>

            {/*================ Table =========================*/}
            <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
              <div
                className="col-12 py-3 shadow border"
                style={{ backgroundColor: 'white' }}
              >
                <div
                  className="col-12 px-md-5"
                  style={{ display: 'flex', justifyContent: 'space-between' }}
                >
                  <div>
                    <span style={{ fontSize: '14px' }}>Show entries &nbsp;</span>
                    <Select
                      defaultValue={pageSize}
                      onChange={handlePageSizeChange}
                      style={{ width: 120, textAlign: 'center' }}
                    >
                      <Option value={10}>10</Option>
                      <Option value={20}>20</Option>
                      <Option value={30}>30</Option>
                    </Select>
                  </div>

                  <div className="pt-4 pt-md-0">
                    <Input.Search
                      placeholder="Search"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ width: 200, marginBottom: 16 }}
                    />
                  </div>
                </div>

                <div style={{ backgroundColor: 'white' }}>
                  <Table
                    bordered
                    style={{ padding: '0px 20px', overflowX: 'auto' }}
                    columns={columns}
                    dataSource={filteredData}
                    pagination={{
                      pageSize: pageSize,
                      total: totalEntries,
                      showTotal: (total, range) =>
                        `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                      current: currentPage,
                      onChange: (page) => setCurrentPage(page),
                    }}
                    showSorterTooltip={false}
                    rowKey={(record) => record.id}
                    components={components}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default JobWorkerItemMaster
